import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'العلاقة',
  },
  az: {
    label: 'Münasibət',
  },
  bg: {
    label: 'Връзка',
  },
  cs: {
    label: 'Vztah',
  },
  da: {
    label: 'Forhold',
  },
  de: {
    label: 'Beziehung',
  },
  en: {
    label: 'Relationship',
  },
  es: {
    label: 'Relación',
  },
  et: {
    label: 'Seos',
  },
  fa: {
    label: 'روابط',
  },
  fr: {
    label: 'Relation',
  },
  he: {
    label: 'יחסים',
  },
  hr: {
    label: 'Odnos',
  },
  hu: {
    label: 'Kapcsolat',
  },
  it: {
    label: 'Relazione',
  },
  ja: {
    label: '関係性',
  },
  ko: {
    label: '관계',
  },
  my: {
    label: 'Hubungan',
  },
  nb: {
    label: 'Forhold',
  },
  nl: {
    label: 'Relatie',
  },
  pl: {
    label: 'Relacja',
  },
  pt: {
    label: 'Relacionamento',
  },
  ro: {
    label: 'Relație',
  },
  rs: {
    label: 'Релација',
  },
  'rs-latin': {
    label: 'Relacija',
  },
  ru: {
    label: 'Отношения',
  },
  sk: {
    label: 'Vzťah',
  },
  sl: {
    label: 'Odnos',
  },
  sv: {
    label: 'Relation',
  },
  th: {
    label: 'ความสัมพันธ์',
  },
  tr: {
    label: 'İlişki',
  },
  uk: {
    label: 'Стосунки',
  },
  vi: {
    label: 'Mối quan hệ',
  },
  zh: {
    label: '关系',
  },
  'zh-TW': {
    label: '關係',
  },
}
